import React, { useEffect, useState } from "react";
import "./css/entry.css";
import "./css/reports.css";
////
import { useLocation } from "react-router-dom";
import moment from "moment";
import TokenService from "./service/TokenService";
import { Box } from "@mui/material";
import apiClient from "./BaseUrl/apiClient";
import dayjs from "dayjs";
//import EncryptService from "./service/EncryptionService";

function Reports() {
  //const navigate = useNavigate();
  const { state } = useLocation();
  let indentId = state.po_id;
  const [reportPOdata, setreportPOdata] = useState([]);
  const [reportMaterialdata, setreportMaterialdata] = useState([]);
  const [reportSuitable, setreportSuitable] = useState([]);
  const [reportBillDetails, setreportBillDetails] = useState([]);
  const [reportBillPassing, setreportBillPassing] = useState([]);
  const [dpExtend, setdpExtend] = useState([]);
  const [reportCRN, setreportCRN] = useState([]);
  const [reportPayment, setreportPayment] = useState([]);
  const [consigneeTPI, setconsigneeTPI] = useState("");
  //let dpDate = dayjs();
  const [olddpDate, setolddpDate] = useState(dayjs());

  //  </div>
  const tokenServiceDetails = TokenService.getUserDetails();
  const uname = tokenServiceDetails?.uname;
  //const uname = sessionStorage.getItem("token");

  ////////////////PO Details///////////////////////
  const getPOData = async (e) => {
if (!indentId || indentId.trim() === "") return;

    try {
      const response11 = await apiClient.post("/poDataReports", {
        vponumber: indentId.toString(),
        vreporttype: "0",
        vuname: uname,
      });
      if (response11.data && response11.data.length > 0) {
        setreportPOdata(response11.data);
        setolddpDate(reportPOdata[0]?.DPDate);
        // console.log();
      } else {
        // Throw an error if no data is found
      }
    } catch (error) {
      // Handle and set the error in state
    }
  };
  ////////////////Materials Details///////////////////////
  const getMaterialData = async (e) => {
    if (!indentId || indentId.trim() === "") return;
    try {
      const response11 = await apiClient.post("/poDataReports", {
        vponumber: indentId.toString(),
        vreporttype: "1",
        vuname: uname,
      });
      if (response11.data && response11.data.length > 0) {
        setreportMaterialdata(response11.data);
        setconsigneeTPI(response11?.data[0]?.tpidonetype);
      } else {
        // Throw an error if no data is found
      }
    } catch (error) {
      // Handle and set the error in state
    }
  };

  ////////////////Suityalility Details///////////////////////
  const getSuityalilityData = async (e) => {
    if (!indentId || indentId.trim() === "") return;
    try {
      const response11 = await apiClient.post("/poDataReports", {
        vponumber: indentId.toString(),
        vreporttype: "2",
        vuname: uname,
      });
      if (response11.data && response11.data.length > 0) {
        setreportSuitable(response11.data);
        // console.log(response11.data);
      } else {
        // Throw an error if no data is found
      }
    } catch (error) {
      // Handle and set the error in state
    }
  };

  ////////////////Bill Details///////////////////////
  const getBillData = async (e) => {
    if (!indentId || indentId.trim() === "") return;
    try {
      const response11 = await apiClient.post("/poDataReports", {
        vponumber: indentId.toString(),
        vreporttype: "3",
        vuname: uname,
      });
      if (response11.data && response11.data.length > 0) {
        setreportBillDetails(response11.data);
        // console.log(response11.data);
      } else {
        // Throw an error if no data is found
      }
    } catch (error) {
      // Handle and set the error in state
    }
  };
  ////////////////Bill Passing///////////////////////
  const getBillPassingData = async (e) => {
    if (!indentId || indentId.trim() === "") return;
    try {
      const response11 = await apiClient.post("/poDataReports", {
        vponumber: indentId.toString(),
        vreporttype: "4",
        vuname: uname,
      });
      if (response11.data && response11.data.length > 0) {
        setreportBillPassing(response11.data);
        // console.log(response11.data);
      } else {
        // Throw an error if no data is found
      }
    } catch (error) {
      // Handle and set the error in state
    }
  };

  ////////////////CRN Details///////////////////////
  const getCRNData = async (e) => {
    if (!indentId || indentId.trim() === "") return;
    try {
      const response11 = await apiClient.post("/poDataReports", {
        vponumber: indentId.toString(),
        vreporttype: "5",
        vuname: uname,
      });
      if (response11.data && response11.data.length > 0) {
        setreportCRN(response11.data);
        // console.log(response11.data);
      } else {
        // Throw an error if no data is found
      }
    } catch (error) {
      // Handle and set the error in state
    }
  };

  ////////////////CRN Details///////////////////////
  const getPaymentDetails = async (e) => {
    if (!indentId || indentId.trim() === "") return;
    try {
      const response11 = await apiClient.post("/poDataReports", {
        vponumber: indentId.toString(),
        vreporttype: "6",
        vuname: uname,
      });
      if (response11.data && response11.data.length > 0) {
        setreportPayment(response11.data);
        // console.log(response11.data);
      } else {
        // Throw an error if no data is found
      }
    } catch (error) {
      // Handle and set the error in state
    }
  };

  ////////////////DP Extend Details///////////////////////
  const getDPExtendDetails = async (e) => {
    if (!indentId || indentId.trim() === "") return;
    try {
      const response11 = await apiClient.post("/poDataReports", {
        vponumber: indentId.toString(),
        vreporttype: "7",
        vuname: uname,
      });
      if (response11.data && response11.data.length > 0) {
        setdpExtend(response11.data);
        // console.log(response11.data);
      } else {
        // Throw an error if no data is found
      }
    } catch (error) {
      // Handle and set the error in state
    }
  };

  useEffect(() => {
    getPaymentDetails();
    getCRNData();
    getSuityalilityData();
    getBillPassingData();
    getBillData();
    getPOData();
    getMaterialData();
    getDPExtendDetails();
  }, []);
  //olddpDate,getBillData,getBillPassingData,getCRNData,getMaterialData,getPOData,getPaymentDetails,getSuityalilityData
  function formatDate(inputDate) {
    if (inputDate) {
      const date = moment(inputDate);

      // Check if the date is valid
      if (date.isValid()) {
        // Return the formatted date
        return date.format("DD-MMM-YYYY");
      } else {
        // Return null if the date is invalid
        return "";
      }
    } else {
      return "";
    }
  }

  return (
    <>
      <div style={{ padding: 20 , position: "relative" }}>

 {/* Watermark */}
  {reportPOdata[0]?.pocancellationstatus && (
    <div className="watermark">
      PO Canceled
    </div>
  )}





        {/* Header */}
       {/* <div style={{  border: '.5px solid black',padding: 1,display: 'flex', justifyContent: 'center', alignItems: 'center' }}> */}
        <div>
          <h4 className="underline-text">
            <center>Mechanical Workshop, NER, Gorakhpur</center>
          </h4>
        </div>

        <Box
          sx={{
            border: ".5px solid black",
            padding: 1,
            display: "flex",
            placeItems: "center",
            minHeight: "50px", // Minimum height to keep styling
            maxWidth: "100%", // Ensure it doesn’t overflow
            overflow: "auto", // Enable scrolling if needed
          }}
        >
          {/* <Box sx={{ border: '.5px solid black',padding: 1}} > */}
          {/* {reportPOdata[0]?.IndentNumber?.toString()} {" Dated: "}
          {formatDate(reportPOdata[0]?.IndentDate.toString())} */}
          <div>
            <h6 style={{ display: "flex", marginRight: "10px" }}>
              {"Indent Details =>"}
            </h6>



            {reportPOdata[0]?.IndentDetails?.split("\n\n").map((line, index) => (
              <div key={index} className="small-text">{line}</div>
            ))}

            {/* <h6 style={{ display: "flex" }}>
              {reportPOdata[0]?.IndentNumber?.toString()} 
            </h6> */}
            {/* <div>
            <h6 style={{ display: "inline", marginRight: "10px" }}>
              {"Indent Qty =>"}
            </h6>
            <h6 style={{ display: "inline" }}>
              {reportPOdata[0]?.IndentQty} {"Value: "}
              {reportPOdata[0]?.IndentValue}
            </h6>
            </div> */}
            <div>
              <h6 style={{ display: "inline", marginRight: "10px" }}>
                {"PO Number =>"}
              </h6>
              <h6 style={{ display: "inline" }}>
                {indentId} {" Dated: "}
                {formatDate(reportPOdata[0]?.PODate.toString())}
              </h6>
            </div>
          </div>

        </Box>

        {/* </div> */}

        {/* PO Details*/}

        <div className="print-content">
          <div className="tdHeadingText ">
            PO Details - PO Type{" "}
            {reportPOdata[0]?.potype_description?.toString()}{" "}
            {",  DP Extension "} {reportPOdata[0]?.dpextension?.toString()}{" "}
            {" Times"} 
          </div>

          {reportPOdata[0]?.gemtype !== 0 && (
            <div className="tdHeadingText">
              GeM Number -{" "}
              {reportPOdata[0]?.gemno?.toString()}{" "}
              , {formatDate(reportPOdata[0]?.gemdate?.toString())}
            </div>
          )}



          {reportPOdata[0]?.pocancellationstatus? (
             
            <div className="tdHeadingText ">
              {" "}
              PO Status:{" "}
              {reportPOdata[0]?.pocancellationstatus?.toString()}
               {" "} Reason:{" "}
              {reportPOdata[0]?.cancleresion?.toString()}
            </div>
           ) : null}

          <Box sx={{ border: ".5px solid black", padding: 1 }}>
            <div className="report_container">
              <div className="report_item">
                {"Consignee : "} {reportPOdata[0]?.Shop?.toString()} {"  "} (
                {reportPOdata[0]?.POConsignee?.toString()})
              </div>
              <div className="report_item">
                {"Supplier : "}
                {reportPOdata[0]?.party_name?.toString()}
              </div>
            </div>

            {/* <div className="report_container">
              <div className="report_item">
                {"Item Name : "}
                {reportPOdata[0]?.POItemName?.toString()}
              </div>
            </div> */}

            <div className="report_container">
              <div className="report_item">
                {" "}
                {"PO Quantity : "} {reportPOdata[0]?.POQty?.toString()}{" "}
                {reportPOdata[0]?.unit?.toString()}
              </div>
              <div className="report_item">
                {" "}
                {"PO Value : "} {reportPOdata[0]?.POValue?.toString()}
              </div>
              <div className="report_item">
                {" "}
                {"DP Date : "}
                {formatDate(reportPOdata[0]?.DPDate.toString())}
              </div>
            </div>
            <div>
              {dpExtend && dpExtend.length > 0 && (
                <>
                  <div className="tdHeadingText">DP Extension Details</div>

                  {dpExtend.map((id, index) => (
                    <React.Fragment key={id.id || index}>
                      {/* <Box sx={{ border: ".5px solid black", padding: 1 }}> */}
                      <div className="report_container">
                        <div className="report_item">
                          {" "}
                          <b>
                            {"Extension Number : "}{" "}
                            {id.extensionnumber || "N/A"}
                          </b>
                        </div>
                        <div className="report_item">
                          {" "}
                          {"OLD Date : "} {formatDate(id.olddpdate) || "N/A"}
                        </div>
                        <div className="report_item">
                          {" "}
                          {"New Date : "} {formatDate(id.newdpdate) || "N/A"}
                        </div>
                      </div>
                      <div className="report_container">
                        <div className="report_item"> </div>
                        <div className="report_item">
                          {" "}
                          {"MA Number : "} {id.manumber || "N/A"}
                        </div>
                        <div className="report_item">
                          {" "}
                          {"MA Date : "} {formatDate(id.madate) || "N/A"}
                        </div>
                      </div>
                      {/* </Box> */}
                    </React.Fragment>
                  ))}
                </>
              )}
            </div>
          </Box>

          {/* Materials Details*/}
          {/* marginBottom: 2, padding: 2 */}
          <div>
            {reportMaterialdata && reportMaterialdata.length > 0 && (
              <>
                <div className="tdHeadingText">Materials Receiving Details</div>
                <Box sx={{ border: ".5px solid black", padding: 1 }}>
                  {reportMaterialdata.map((id, index) => (
                    <React.Fragment key={id.id || index}>
                      {/* Section 1 */}
                      <div className="report_container">
                        <div className="report_item">
                          <b>
                            {"Gate Pass Number : "} {id.getpassnumber || "N/A"}
                          </b>
                        </div>
                        <div className="report_item"></div>
                        <div className="report_item">
                          {" "}
                          <b>
                            {"Receiving Date : "}{" "}
                            {formatDate(id.itemReceivedDate) || "N/A"}
                          </b>
                        </div>
                      </div>
                      {/* Section 2 */}
                      <div className="report_container">
                        <div className="report_item">
                          {"Quantity : "} {id.receivedItemQty || "N/A"} (
                          <b>{id.itemrecicingtype || "N/A"} </b>)
                        </div>
                        <div className="report_item"></div>
                        <div className="report_item">
                          {"Value : "} {id.receivedItemValue || "N/A"}
                        </div>
                      </div>

                      {/* Section 3 */}

                      {/* { id.tpidonetype==="Consignee" &&} */}

                      <div className="report_container">
                        <div className="report_item">
                          {"Inspection Type : "} {id.tpidonetype || "N/A"}
                          {/* {settpiType(id.tpidonetype)} */}
                        </div>
                        {id.tpidonetype !== "Consignee" && (
                          <>
                            <div className="report_item">
                              {"TPI Agency : "} {id.tpiagency || "N/A"}
                            </div>
                            <div className="report_item">
                              {"TPI Date : "} {formatDate(id.tpidate) || "N/A"}
                            </div>
                          </>
                        )}
                      </div>

                      {index < reportMaterialdata.length - 1 && (
                        <div
                          style={{
                            height: "1px",
                            backgroundColor: "black",
                            margin: "10px 0",
                          }}
                        ></div>
                      )}
                    </React.Fragment>
                  ))}
                </Box>
              </>
            )}
          </div>

          {/* Suitablility Details*/}
          {consigneeTPI === "Consignee" && (
            <div>
              {reportSuitable && reportSuitable.length > 0 && (
                <>
                  <div className="tdHeadingText">Suitablility Details</div>
                  <Box sx={{ border: ".5px solid black", padding: 1 }}>
                    {reportSuitable.map((id, index) => (
                      <React.Fragment key={id.id || index}>
                        <div className="report_container">
                          <div className="report_item">
                            {" "}
                            {"Gate Pass Number : "} {id.getpassnumber || "N/A"}
                          </div>
                          <div className="report_item">
                            {" "}
                            {"Received Qty. : "} {id.receivedItemQty || "N/A"}
                          </div>
                          <div className="report_item">
                            {" "}
                            <b>
                              {"Suitable Qty. : "}
                              {id.SuitabilityQty || "N/A"}
                            </b>
                          </div>
                          <div className="report_item">
                            {" "}
                            {"Suitablily Date : "}
                            {formatDate(id.SuitabilityDate) || "N/A"}
                          </div>
                        </div>

                        <div className="report_container">
                          <div className="report_item">
                            {" "}
                            {"Memo Date : "}
                            {formatDate(id.memodate) || "N/A"}
                          </div>

                          <div className="report_item">
                            {" "}
                            {"Suitability Type : "}
                            <b>{id.SuitabilityDescriptaion || "N/A"}</b>
                          </div>

                          {id.SuitabilityDescriptaion !== "Item Suitable" && (
                            <>
                              <div className="report_item">
                                {" "}
                                {"Reason : "}
                                {id.reason || "N/A"}
                              </div>
                              <div className="report_item"></div>
                            </>
                          )}
                        </div>

                        {index < reportSuitable.length - 1 && (
                          <div
                            style={{
                              height: "1px",
                              backgroundColor: "black",
                              margin: "10px 0",
                            }}
                          ></div>
                        )}
                      </React.Fragment>
                    ))}
                  </Box>
                </>
              )}
            </div>
          )}

          {/* Bill Details*/}
          <div>
            {reportBillDetails && reportBillDetails.length > 0 && (
              <>
                <div className="tdHeadingText">Bill Details</div>
                <Box sx={{ border: ".5px solid black", padding: 1 }}>
                  {reportBillDetails.map((id, index) => (
                    <React.Fragment key={id.id || index}>
                      <div className="report_container">
                        <div className="report_item">
                          {" "}
                          <b>
                            {" "}
                            {"Bill Number : "}
                            {id.billnumber || "N/A"}{" "}
                          </b>
                        </div>
                        <div className="report_item">
                          {" "}
                          <b>
                            {"Bill Date : "}
                            {formatDate(id.billdate) || "N/A"}{" "}
                          </b>
                        </div>
                        <div className="report_item">
                          {" "}
                          {"Bill Receiving Date : "}
                          {formatDate(id.billreceiptdate) || "N/A"}
                        </div>
                      </div>

                      <div className="report_container">
                        <div className="report_item">
                          {" "}
                          {"Quantity : "}
                          {id.billitemQty || "N/A"}
                        </div>
                        <div className="report_item">
                          {" "}
                          {"Value : "}
                          {id.billitemValue || "N/A"}
                        </div>
                        <div className="report_item">
                          {" "}
                          {"Bill Type : "}
                          {id.pmnttype || "N/A"}
                        </div>
                      </div>
                      {index < reportSuitable.length - 1 && (
                        <div
                          style={{
                            height: "1px",
                            backgroundColor: "black",
                            margin: "10px 0",
                          }}
                        ></div>
                      )}
                    </React.Fragment>
                  ))}
                </Box>
              </>
            )}
          </div>

          {/* Bill Passing Details*/}
          <div>
            {reportBillPassing && reportBillPassing.length > 0 && (
              <>
                <div className="tdHeadingText">Bill Passing Details</div>
                <Box sx={{ border: ".5px solid black", padding: 1 }}>
                  {reportBillPassing.map((id, index) => (
                    <React.Fragment key={id.id || index}>
                      <div className="report_container">
                        <div className="report_item">
                          {" "}
                          <b>
                            {"Bill Number : "} {id.billnumber || "N/A"}
                          </b>
                        </div>
                        <div className="report_item">
                          {" "}
                          {"Receiving Date : "}
                          {formatDate(id.billreceivingdate) || "N/A"}{" "}
                        </div>
                        <div className="report_item">
                          {" "}
                          {"Passing Date : "}{" "}
                          {formatDate(id.billpassingdate) || "N/A"}
                        </div>
                      </div>
                      {/* {index < reportBillPassing.length - 1 && (
  <div
    style={{
      height: "1px",
      backgroundColor: "black",
      margin: "10px 0",
    }}
  ></div>
)} */}
                    </React.Fragment>
                  ))}
                </Box>
              </>
            )}
          </div>

          {/* CRN Details*/}
          <div>
            {reportCRN && reportCRN.length > 0 && (
              <>
                <div className="tdHeadingText">CRN Details</div>
                <Box sx={{ border: ".5px solid black", padding: 1 }}>
                  {reportCRN.map((id, index) => (
                    <React.Fragment key={id.id || index}>
                      <div className="report_container">
                        <div className="report_item">
                          {" "}
                          <b>
                            {"Bill Number : "} {id.billnumber || "N/A"}
                          </b>
                        </div>
                        <div className="report_item">
                          {" "}
                          {"CRN Number : "} {id.crnnumber || "N/A"}
                        </div>
                        <div className="report_item">
                          {" "}
                          {"CRN Date : "} {formatDate(id.crndate) || "N/A"}
                        </div>
                      </div>

                      {/* {index < reportCRN.length - 1 && (
  <div
    style={{
      height: "1px",
      backgroundColor: "black",
      margin: "10px 0",
    }}
  ></div>
)} */}
                    </React.Fragment>
                  ))}
                </Box>
              </>
            )}
          </div>

          {/* <PageBreak /> */}
          {/* Payment Details*/}
          <div>
            {reportPayment && reportPayment.length > 0 && (
              <>
                <div className="tdHeadingText">Payment Details</div>
                <Box sx={{ border: ".5px solid black", padding: 1 }}>
                  {reportPayment.map((id, index) => (
                    <React.Fragment key={id.id || index}>
                      <div className="report_container">
                        <div className="report_item">
                          {" "}
                          <b>
                            {"Bill Number : "} {id.billnumber || "N/A"}
                          </b>
                        </div>
                        <div className="report_item">
                          {" "}
                          {"CO6 Number : "} {id.co6number || "N/A"}
                        </div>
                        <div className="report_item">
                          {" "}
                          {"CO6 Date : "} {formatDate(id.co6date) || "N/A"}
                        </div>
                      </div>

                      <div className="report_container">
                        <div className="report_item">
                          {" "}
                          {"CO7 Number : "} {id.co7number || "N/A"}
                        </div>
                        <div className="report_item">
                          {" "}
                          {"CO7 Date : "} {formatDate(id.co7date) || "N/A"}
                        </div>
                        <div className="report_item">
                          {" "}
                          <b>
                            {"Payment Date : "}{" "}
                            {formatDate(id.paymentdate) || "N/A"}
                          </b>
                        </div>
                      </div>

                      {index < reportPayment.length - 1 && (
                        <div
                          style={{
                            height: "1px",
                            backgroundColor: "black",
                            margin: "10px 0",
                          }}
                        ></div>
                      )}
                    </React.Fragment>
                  ))}
                </Box>
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default Reports;
